/* eslint-disable */
import React, { Component, Button } from 'react';
import { connect } from 'react-redux';
import SubscriptionTable from './table';
import { withRefreshTableOnFilterChange } from '../../common/decorators';
import actions from '../../../../actions';

import history from '../../../../history';

@withRefreshTableOnFilterChange
class SubscriptionContainer extends Component {
    render() {
        let pages = -1;
        let showPaginationBottom = false;
        if (this.props.meta) {
            pages = Math.ceil(this.props.meta.count / 20);
            showPaginationBottom = this.props.meta.count > 20;
        }
        const data = this.props.content ? this.props.content : [];
        const currentUrlParams = new URLSearchParams(history.location.search);
        return (
            <SubscriptionTable
                data={data}
                pages={pages}
                loading={this.props.fetching}
                history={history}
                showPaginationBottom={showPaginationBottom}
                onShiftsSelected={this.props.onShiftsSelected}
                user={this.props.user}
                onFetchData={(state, instance) => {
                    this.props.load(currentUrlParams);
                }}
            />
        );
    }
}

const mapStateToProps = (state, ownProps) => ({
    ...state.subscriptions,
    user: state.user,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
    load: param => dispatch(actions.loadSubscriptions(param)),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(SubscriptionContainer);
